import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
// Use: window.dispatchEvent(new CustomEvent("toast:show", { detail: { message: "Text", type: "success" } }))
// Or: import { toast } from "../utils/toast" then toast("Message", { type: "info" })
//
// type: "primary" | "secondary" | "accent" | "neutral" | "info" | "success" | "warning" | "error"
const VALID_TYPES = ["primary", "secondary", "accent", "neutral", "info", "success", "warning", "error"]

const ICON_BY_TYPE = {
  info: "lucide--info",
  success: "lucide--circle-check",
  warning: "lucide--triangle-alert",
  error: "lucide--circle-x",
  primary: "lucide--info",
  secondary: "lucide--info",
  accent: "lucide--info",
  neutral: "lucide--info"
}

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 4000 }
  }

  connect() {
    this.boundHandleShow = this.handleShow.bind(this)
    window.addEventListener("toast:show", this.boundHandleShow)
  }

  disconnect() {
    window.removeEventListener("toast:show", this.boundHandleShow)
  }

  handleShow(event) {
    const { message, type = "info", delay } = event.detail || {}
    if (!message) return
    this.show(message, type, delay)
  }

  show(message, type = "info", delayOverride) {
    const alertType = VALID_TYPES.includes(type) ? type : "info"
    const alertClass = `alert-${alertType}`
    const alert = document.createElement("div")
    alert.role = "alert"
    alert.className = `alert ${alertClass} shadow-lg`
    const iconClass = `icon-[${ICON_BY_TYPE[alertType]}]`
    alert.innerHTML = `<span class="${iconClass} size-6 shrink-0"></span><span>${this.escapeHtml(message)}</span>`
    this.element.appendChild(alert)

    const delay = delayOverride ?? this.delayValue
    setTimeout(() => alert.remove(), delay)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
